import { ControllerPaletteColor } from './__palette-color';

export enum ControllerMonthPickerColor {
  BorderDisabled = ControllerPaletteColor.Gray800,
  BorderNormal = ControllerPaletteColor.Gray600,
  BorderSelected = ControllerPaletteColor.Ngb500,
  DisabledFg = ControllerPaletteColor.Gray800,
}
